import React from 'react';
import {
  LBInput,
  LBRadioGroup,
  LBRadioGroupItem,
  LBLabel
} from '@linearb/buzz';
import { COPILIT_SETTING_SELECTION_TYPES } from './definitions';
import useGithubOrgsOptions from '../../RepositoriesV2/GitIntegration/MonitoringRules/form-components/GithubOrgsSelector/useGithubOrgsOptions';
import GithubOrgsSelector from '../../RepositoriesV2/GitIntegration/MonitoringRules/form-components/GithubOrgsSelector/GithubOrgsSelector';
import {
  GithubOrgsData,
  OrganizationSelectionType
} from './CopilotSetting.types';
import { SensorAuthorization } from 'types';

interface OrganizationsConfigProps {
  integration?: SensorAuthorization;
  disabled?: boolean;
  selectionMethod: OrganizationSelectionType;
  regexPattern: string;
  selectedOrgs: string[];
  onSelectionMethodChange?: (method: OrganizationSelectionType) => void;
  onRegexPatternChange?: (pattern: string) => void;
  onSelectedOrganizationsChange?: (organizations: string[]) => void;
}

const OrganizationsConfig: React.FC<OrganizationsConfigProps> = ({
  integration,
  disabled = false,
  selectionMethod,
  regexPattern = '',
  selectedOrgs = [],
  onSelectionMethodChange = () => {},
  onRegexPatternChange = () => {},
  onSelectedOrganizationsChange = () => {}
}) => {
  const githubOrgs: GithubOrgsData = useGithubOrgsOptions(integration, []);

  return (
    <div className={`${disabled ? 'pointer-events-none opacity-50' : ''}`}>
      {/* Radio Button Options */}
      <LBRadioGroup
        value={selectionMethod}
        onValueChange={onSelectionMethodChange}
      >
        {/* Include all organizations */}
        <div className='flex items-center gap-3'>
          <LBRadioGroupItem
            id='all-orgs'
            value={COPILIT_SETTING_SELECTION_TYPES.ALL}
          />
          <LBLabel className='text-sm' htmlFor='all-orgs'>
            Include all organizations
          </LBLabel>
        </div>

        {/* Select organizations by regex */}
        <div className='flex items-center gap-3'>
          <LBRadioGroupItem
            id='regex-orgs'
            value={COPILIT_SETTING_SELECTION_TYPES.REGEX}
          />
          <LBLabel className='text-sm' htmlFor='regex-orgs'>
            Select organizations by regex
          </LBLabel>

          <LBInput
            type='text'
            placeholder='.*'
            value={regexPattern}
            onChange={e => onRegexPatternChange(e.target.value)}
            disabled={selectionMethod !== COPILIT_SETTING_SELECTION_TYPES.REGEX}
            className='w-[30rem]'
          />
        </div>

        {/* Select organizations manually */}
        <div className='flex items-start gap-3'>
          <LBRadioGroupItem
            id='manual-orgs'
            value={COPILIT_SETTING_SELECTION_TYPES.CUSTOM}
          />
          <LBLabel className='text-sm' htmlFor='manual-orgs'>
            Select organizations manually
          </LBLabel>

          <GithubOrgsSelector
            githubOrgs={githubOrgs}
            integration={integration}
            onChange={onSelectedOrganizationsChange}
            filterUnExistedOrgs={() => {}}
            selectedValues={selectedOrgs}
            disabled={
              selectionMethod !== COPILIT_SETTING_SELECTION_TYPES.CUSTOM
            }
            width='30rem'
          />
        </div>
      </LBRadioGroup>
    </div>
  );
};

export default OrganizationsConfig;
